export const svgWidthLg = 673;
export const svgWidthSm = 240;
export const classNameLg = 'vx-hidden vx-overflow-visible vx-h-auto vx-max-w-full @md:vx-block';
export const classNameSm = 'vx-h-auto vx-overflow-visible vx-max-w-full @md:vx-hidden';
